@if (!IsLoading) {
  <div>
    <h5>
      We’ve received your application so we can now get things moving. We’ve given it a unique reference number of {{"Q"+outcome.CaseReference}},
      which we’ve also emailed to you.
    </h5>
    <p>
      Our expert team will be in touch shortly, in the meantime, if you’d like to speak to us call <a href="tel:+01614513157">0161 768 5337</a>.</p>
      <p>
        <a href="http://www.togethermoney.com" target="_blank" title="Visit our website">Visit our website</a> to find out everything from how auction finance works, to handy tips for the big day.
      </p>
    </div>
  }
  @if (IsLoading) {
    <div>
      <h3>Please wait a moment while we load your details..</h3>
    </div>
  }
  <together-auction-dip-loading [is_loading]="IsLoading"></together-auction-dip-loading>